import React from "react";
import {withNamespaces} from "react-i18next";

const ConfirmModal = ({t, closeModal, confirmAction, confirmLabel, confirmIcon, classNameBtnConfirm = 'btn-primary', title, message, dataId}) => {
    return (
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <div dangerouslySetInnerHTML={{ __html: message}} />
            </div>
            <div className="modal-footer">
                <button type="button" className={"btn " + classNameBtnConfirm} onClick={() => confirmAction(dataId)}>
                    { !confirmIcon || (  <i className={'fas ' + confirmIcon + ' mr-2 '}> </i>  ) }
                    {t(confirmLabel)}
                </button>
                <button type="button" className="btn btn-secondary" onClick={closeModal}>{t('close')}</button>
            </div>
        </div>
    )
};
export default withNamespaces()(ConfirmModal);
